import HiddenBalancesIcon from '@/shared/assets/hidden-balances-icon.svg?react';
import DisplayedBalancesIcon from '@/shared/assets/displayed-balances-icon.svg?react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui';
import { useMediaQuery } from '@/shared/lib';
import { cn } from '@/shared/utils';

interface Props {
  isBalancesHidden: boolean;
  title?: string;
  setIsBalancesHidden: () => void;
  ariaLabel?: string;
}

export const HideBalanceSection = ({
  isBalancesHidden,
  setIsBalancesHidden,
  title,
  ariaLabel,
}: Props) => {
  const isTabletUp = useMediaQuery('(min-width: 1068px)');

  const Icon = isBalancesHidden ? DisplayedBalancesIcon : HiddenBalancesIcon;
  const label = ariaLabel ?? title;

  const trigger = (
    <button
      type="button"
      aria-label={label}
      onClick={() => setIsBalancesHidden()}
      className={cn(
        'cursor-pointer h-[2.4rem] flex flex-row items-center justify-center gap-[0.4rem]',
        !title &&
          'size-[2.4rem] p-[0.4rem] rounded-[0.8rem] border border-stroke bg-background hover:bg-secondary-bg transition-colors'
      )}>
      <Icon className={'h-[1.6rem] w-[1.6rem] text-secondary'} />
      {title && <span className={'medium6 text-secondary'}>{title}</span>}
    </button>
  );

  if (!isTabletUp || title || !label) {
    return trigger;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{trigger}</TooltipTrigger>
      <TooltipContent
        side="top"
        sideOffset={11}
        className="border-0 rounded-[0.8rem] bg-primary px-[1.2rem] pt-[0.3rem] pb-[0.4rem] medium6 text-tertiary-light shadow-[0px_0px_16px_0px_rgba(24,26,33,0.16)]">
        {label}
      </TooltipContent>
    </Tooltip>
  );
};
